import { T_APP_CONFIG_CHECKER_PAGE_CONSTANTS } from './TYPES'

const FR_APP_CONFIG_CHECKER_PAGE_CONSTANTS: T_APP_CONFIG_CHECKER_PAGE_CONSTANTS =
  {
    OPTIONAL_UPDATE_HEADER: 'Mise à jour disponible',
    OPTIONAL_UPDATE_DESCRIPTION:
      "Pour profiter des dernières fonctionnalités et améliorations, veuillez mettre à jour l'application.",
    OPTIONAL_UPDATE_CONFIRM_BTN_TEXT: 'Mettre à jour',
    OPTIONAL_UPDATE_CANCEL_BTN_TEXT: 'Pas maintenant',
    FORCE_UPDATE_HEADER: 'Mise à jour requise',
    FORCE_UPDATE_DESCRIPTION:
      'Une nouvelle version de l’application est disponible et requise pour continuer. Veuillez la mettre à jour maintenant pour poursuivre.',
    FORCE_UPDATE_CONFIRM_BTN_TEXT: 'Mettre à jour maintenant'
  }

export default FR_APP_CONFIG_CHECKER_PAGE_CONSTANTS
